import Vue, { PropType } from "vue";
import { ISettingsData } from "js/crossword/settingsData";

import style from "../css/FormElements.module.css";

enum InputPosition {
  LEFT = "left",
  RIGHT = "right"
}

export const RadioButton = Vue.extend({
  props: {
    label: String,
    target: Object,
    targetKey: String,
    value: [String, Boolean],
    inputPosition: {
      type: String,
      default: InputPosition.RIGHT,
    },
  },
  render() {
    return (
      <div
        class={style.inputDiv}
        style={{ flexDirection: getDirection(this.inputPosition) }}
      >
        <label>{this.label}</label>
        <div class={style.spaceBetween}></div>
        <input
          class={style.input}
          type="radio"
          vModel={this.target[this.targetKey]}
          value={this.value}
        />
      </div>
    );
  },
});

export const Checkbox = Vue.extend({
  props: {
    label: String,
    target: Object as PropType<ISettingsData>,
    targetKey: String,
    value: [String, Boolean],
    inputPosition: {
      type: String,
      default: InputPosition.RIGHT,
    },
  },
  render() {
    return (
      <div
      class={style.inputDiv}
      style={{ flexDirection: getDirection(this.inputPosition) }}
    >
        <label>{this.label}</label>
        <div class={style.spaceBetween}></div>
        <input
          class={style.input}
          type="checkbox"
          vModel={this.target[this.targetKey]}
          value={this.value}
        />
      </div>
    );
  },
});


function getDirection(inputPosition: string): "row" | "row-reverse" {
  return inputPosition === InputPosition.LEFT
  ? "row-reverse"
  : "row";
}
